export const DEAL_SUMMARY_PDF_STAGES = [
    'socketEventReceived',
    'refreshModalShown',
    'refreshRequested',
    'dealFetched',
    'pdfFetchRequested',
    'pdfUrlReceived'
] as const;

export type DealSummaryPdfStage = (typeof DEAL_SUMMARY_PDF_STAGES)[number];

export type DealSummaryPdfStageMarks = Partial<Record<DealSummaryPdfStage, number>>;

export type DealSummaryPdfTiming = {
    cycleId: number;
    marks: DealSummaryPdfStageMarks;
    context: Record<string, unknown>;
    pdfFetchAttempts: number;
};

let nextCycleId = 1;

const emptyCycle = (): DealSummaryPdfTiming => ({ cycleId: nextCycleId++, marks: {}, context: {}, pdfFetchAttempts: 0 });

let cycle: DealSummaryPdfTiming = emptyCycle();

export const markDealSummaryPdfStage = (stage: DealSummaryPdfStage): void => {
    if (stage === 'socketEventReceived') {
        cycle = emptyCycle();
    }
    if (stage === 'pdfFetchRequested') {
        cycle.pdfFetchAttempts += 1;
    }
    cycle.marks[stage] = performance.now();
};

export const setDealSummaryPdfTimingContext = (context: Record<string, unknown>): void => {
    cycle.context = { ...cycle.context, ...context };
};

export const readDealSummaryPdfTiming = (): DealSummaryPdfTiming => ({
    cycleId: cycle.cycleId,
    marks: { ...cycle.marks },
    context: { ...cycle.context },
    pdfFetchAttempts: cycle.pdfFetchAttempts
});

export const resetDealSummaryPdfTiming = (cycleId?: number): void => {
    if (cycleId !== undefined && cycleId !== cycle.cycleId) {
        return;
    }
    cycle = emptyCycle();
};
